// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"not-found_pageNotFound__ODQu6","number":"not-found_number__TljVQ","info":"not-found_info__eH281","buttonBack":"not-found_buttonBack__CZKRo"};